import { type HTMLAttributes, type ReactNode } from 'react';
import { cn } from './cn';

export interface DescriptionListProps extends HTMLAttributes<HTMLDListElement> {
  children: ReactNode;
}

export function DescriptionList({ className, children, ...rest }: DescriptionListProps) {
  return (
    <dl className={cn('ui-dl', className)} {...rest}>
      {children}
    </dl>
  );
}

export interface DescriptionItemProps extends HTMLAttributes<HTMLDivElement> {
  term: ReactNode;
  children: ReactNode;
}

export function DescriptionItem({ term, children, className, ...rest }: DescriptionItemProps) {
  return (
    <div className={cn('ui-dl__row', className)} {...rest}>
      <dt className="ui-dl__term">{term}</dt>
      <dd className="ui-dl__detail">{children}</dd>
    </div>
  );
}
